import {Box} from '@esgi/ui/layout';
import {styled} from '@stitches/react';

export const ContainerStyled = styled(Box, {
	paddingTop: '20px',
	paddingBottom: '10px',
});